import { deleteAssignedLessons } from "api/services/lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useDeleteAssignedLessons = () => {
    const { callAPI, loading } = useWorkspaceApiCall(deleteAssignedLessons, 'deleteAssignedLessons.success', 'deleteAssignedLessons.error');

    return { deleteAssignedLessons: callAPI, deletingAssignedLessons: loading };
}